<template>
    <div>
        <div class="card">
            <div class="card-header">
                项目批次信息
            </div>
            <table class="table table-bordered mb-0">
                <tbody>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">批次名称</th>
                    <td class="text-left align-middle" colspan="5">{{ batchInfo.batchName }}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">财政年份</th>
                    <td class="text-left align-middle" style="width: 15%">{{ batchInfo.fileYear }}</td>
                    <th class="text-center align-middle" style="width: 10%">实施年份</th>
                    <td class="text-left align-middle" style="width: 15%">{{ batchInfo.implYear }}</td>
                    <th class="text-center align-middle" style="width: 10%">状态</th>
                    <td class="text-left align-middle" style="width: 40%">{{ batchInfo.stateName }}</td>
                </tr>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">批次备注</th>
                    <td class="text-left align-middle" colspan="5">{{ batchInfo.memo }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <project-batch-requirement-view :batch-id="batchId" class="mt-3"></project-batch-requirement-view>
        <project-batch-category-view :batch-id="batchId" class="mt-3"></project-batch-category-view>
        <project-batch-contact-view :batch-id="batchId" class="mt-3"></project-batch-contact-view>
        <project-batch-file-view :batch-id="batchId" class="mt-3"></project-batch-file-view>
    </div>

</template>

<script>
import projectApi from "@/utils/api/project";
import ProjectBatchRequirementView from "@/components/project/batch/ProjectBatchRequirementView";
import ProjectBatchCategoryView from "@/components/project/batch/ProjectBatchCategoryView";
import ProjectBatchContactView from "@/components/project/batch/ProjectBatchContactView";
import ProjectDataManage from "@/components/project/project/ProjectDataManage";
import ProjectBatchFileView from "@/components/project/batch/ProjectBatchFileView";

export default {
    name: "ProjectBatchInfoView",
    props: {
        batchId: {type: String, required: true},
    },
    components: {
        ProjectBatchFileView,
        ProjectDataManage,
        ProjectBatchContactView,
        ProjectBatchCategoryView,
        ProjectBatchRequirementView,
    },
    data: function () {
        return {
            batchInfo: {},
        };
    },
    mounted() {
        this.getProjectBatchInfo();
    },
    methods: {
        getProjectBatchInfo() {
            projectApi.batch.getProjectBatchInfo(this.batchId).then(res => {
                this.batchInfo = res.data;
            });
        },

        btnShowBatchRequirementDialog_Click() {
            this.isBatchRequirementInfoDialogOpen = true;
        },
        btnShowBatchCategoryDialog_Click() {
            this.isBatchCategoryInfoDialogOpen = true;
        },
        btnShowBatchContactDialog_Click() {
            this.isBatchContactInfoDialogOpen = true;
        },
    }
}
</script>

<style scoped>

</style>